<template>
    <div class="error404 mt-5">
        <h4>Page not found.</h4>
        <p class="mt-5">
			We are sorry but the page you are looking for does not exist or has been moved.
		</p>
    </div>

</template>

<script>
export default {
  name: 'Error404',
  data () {
    return {

    }
  }
}
</script>

<style lang="sass" scoped>
    body.show-nav
        .error404
            padding-top: 90px
    .error404
        padding-top: 90px
        height: calc(100vh - 90px)
        p
            font-size: 0.9rem
            color: rgba(0,0,0,0.9)
            letter-spacing: 0.5px
            line-height: 27px
</style>
